/*
 *  Not all browsers implement NodeList.forEach()
 *
 *  Use this to loop on all nodes
 */
export function forEach(arrayLike, callback) {
  const len = arrayLike.length;
  let i;

  for (i = 0; i < len; i += 1) {
    callback(arrayLike[i], i, arrayLike);
  }
}

/*
 * Parses an HTML string and returns its plain-text content.
 */
export function htmlToText(html?: string): string {
  if (!html) return '';
  const node = document.createElement('div');
  node.innerHTML = html;
  return node.textContent?.trim() ?? '';
}

/*
 *  Does any parent of the Node pass the truth check?
 */
export function hasParentMatching(childElement, testCallback) {
  let parent = childElement ? childElement.parentNode : null;

  while (parent !== null) {
    if (testCallback(parent)) {
      return true;
    }
    parent = parent.parentNode;
  }

  return false;
}
